var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCircleLoadingBackground = function SvgCircleLoadingBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.5 8.286a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-13.758 0a5.758 5.758 0 1 0 11.516 0 5.758 5.758 0 0 0-11.516 0Z",
    fill: "url(#circle-loading-background_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "circle-loading-background_svg__a",
    x1: 24.649,
    y1: 49.195,
    x2: -1.959,
    y2: 48.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3C622"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#F953C6"
  })))));
};
export default SvgCircleLoadingBackground;